// extracted by mini-css-extract-plugin
export var btnHolder = "Video-module--btnHolder--c7424";
export var frameContainer = "Video-module--frameContainer--c3f77";
export var gatsbyImageWrapper = "Video-module--gatsby-image-wrapper--d57e6";
export var thumbnailHolder = "Video-module--thumbnailHolder--07623";